import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1"
}
const _hoisted_2 = { class: "tw-text-[12px] tw-font-normal tw-text-[#211F58] tw-px-2" }
const _hoisted_3 = { class: "tw-text-[#878787] tw-min-w-[180px] tw-max-w-[180px] tw-capitalize" }
const _hoisted_4 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-flex-1"
}
const _hoisted_5 = { class: "tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1" }


export default /*#__PURE__*/_defineComponent({
  __name: 'cellDetailType2',
  props: {
    title: { default: "" },
    detail: { default: null },
    isShowDetail: { type: Boolean, default: false },
    level: { default: 0 }
  },
  setup(__props: any) {



const renderValue = (value: any, suffix?: string) => {
  return `${value === null ? "N/A" : `${value}`}${suffix || ""}`;
};

return (_ctx: any,_cache: any) => {
  const _component_CellDetailType2 = _resolveComponent("CellDetailType2", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowDetail && !!_ctx.detail)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (Array.isArray(_ctx.detail))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tw-flex !tw-flex-col tw-flex-1",
                style: _normalizeStyle(`background-color: ${_ctx.level >= 1 ? '#FCFCFC' : '#fff'}`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "tw-flex tw-flex-1 tw-min-h-[26px] tw-py-1 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
                  }, [
                    _createElementVNode("span", {
                      class: "tw-text-[12px] tw-font-normal tw-text-[#878787]",
                      style: _normalizeStyle(`margin-left: ${
            !_ctx.level ? 8 : 35 * _ctx.level
          }px; margin-right: 8px; color: ${_ctx.level >= 1 ? '#878787' : '#211F58'}`)
                    }, _toDisplayString(renderValue(item)), 5)
                  ]))
                }), 128))
              ], 4))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Object.entries(_ctx.detail), ([key, value]) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "tw-flex tw-items-center tw-flex-1 tw-min-h-[26px] tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
                }, [
                  (typeof value !== 'object' || !value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "tw-flex tw-text-[12px] tw-font-normal tw-break-words tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1",
                        style: _normalizeStyle(`margin-left: ${
            !_ctx.level ? 8 : 35 * _ctx.level
          }px; margin-right: 8px`)
                      }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(renderValue(key, ":")), 1),
                        _createElementVNode("span", {
                          class: "tw-text-[#211F58] tw-min-w-[180px] tw-max-w-[180px]",
                          style: _normalizeStyle(`color: ${_ctx.level >= 1 ? '#878787' : '#211F58'}`)
                        }, _toDisplayString(renderValue(value)), 5)
                      ], 4))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", {
                            class: "tw-text-[12px] tw-font-normal tw-text-[#878787] tw-min-w-[180px] tw-max-w-[180px] tw-capitalize",
                            style: _normalizeStyle(`margin-left: ${
                !_ctx.level ? 8 : 35 * _ctx.level
              }px; margin-right: 8px`)
                          }, _toDisplayString(renderValue(key, ":")), 5)
                        ]),
                        (Array.isArray(value))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_CellDetailType2, {
                                key: index,
                                detail: item,
                                level: _ctx.level + 1,
                                "is-show-detail": _ctx.isShowDetail
                              }, null, 8, ["detail", "level", "is-show-detail"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_CellDetailType2, {
                              key: 1,
                              detail: value,
                              level: _ctx.level + 1,
                              "is-show-detail": _ctx.isShowDetail
                            }, null, 8, ["detail", "level", "is-show-detail"]))
                      ]))
                ]))
              }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})